// extracted by mini-css-extract-plugin
module.exports = {"portal":"Popover_portal__Nt4Lh","content":"Popover_content__zw3vp","noPadding":"Popover_noPadding__aPC59","noElevation":"Popover_noElevation__rLpWF","arrow":"Popover_arrow__Tgb7w"};